import React from 'react';

export interface CustomIconProps extends React.SVGProps<SVGSVGElement> {
  width?: number;
  height?: number;
  fill?: string;
}

const LibraryIcon: React.FC<CustomIconProps & { outlined?: boolean }> = ({
  width,
  height,
  fill,
  outlined,
  ...rest
}) => {
  return (
    <svg
      width={width ? width : '24'}
      height={height ? height : '24'}
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <path
        d='M16.6667 18.3334H3.33333C3.11232 18.3334 2.90036 18.2456 2.74408 18.0893C2.5878 17.9331 2.5 17.7211 2.5 17.5001V2.50008C2.5 2.27907 2.5878 2.06711 2.74408 1.91083C2.90036 1.75455 3.11232 1.66675 3.33333 1.66675H16.6667C16.8877 1.66675 17.0996 1.75455 17.2559 1.91083C17.4122 2.06711 17.5 2.27907 17.5 2.50008V17.5001C17.5 17.7211 17.4122 17.9331 17.2559 18.0893C17.0996 18.2456 16.8877 18.3334 16.6667 18.3334ZM5.83333 3.33341H4.16667V16.6667H15.8333V3.33341H11.6667V10.8334L8.75 9.16675L5.83333 10.8334V3.33341Z'
        fill='currentColor'
      />
    </svg>
  );
};

export default LibraryIcon;
